import { ApiUtilsService } from './api-utils.service';

export default angular
  .module('sfMobile.services.api-utils', [])
  .factory('apiUtilsService', ApiUtilsService).name;
